import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  MapSettingsOutOfSyncContainer, type MapSettingsOutOfSyncContainerProps,
} from './mapSettingsOutOfSync.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MapSettingsOutOfSync: MapSettingsOutOfSyncContainerProps;
  }
}

modalRenderer.register('MapSettingsOutOfSync', MapSettingsOutOfSyncContainer);
